import React from "react";
import printIcon from "../../../img/printIcon.svg";
import editIcon from "../../../img/editIcon.svg";
import deleteIcon from "../../../img/deleteIcon.svg";

const TableRowMenu = (props) => {

    const {
        index,
        activeTableRowMenu,
        handelTableMenu
    } = props;

    return (
        <div className={activeTableRowMenu === index ? "table-row-menu" : "table-row-menu hide"}>
            <div className="table-row-menu__item">
                <img className="table-row-menu__item-icon" src={printIcon} alt={'иконка печать'}/>
                <p className="table-row-menu__item-name">Menu item</p>
            </div>
            <div onClick={() => handelTableMenu(index)} className="table-row-menu__item">
                <img className="table-row-menu__item-icon" src={editIcon} alt={'иконка печать'}/>
                <p className="table-row-menu__item-name">Menu item</p>
            </div>
            <div className="table-row-menu__item">
                <img className="table-row-menu__item-icon" src={deleteIcon} alt={'иконка печать'}/>
                <p className="table-row-menu__item-name">Menu item</p>
            </div>
        </div>
    )
}
export default TableRowMenu;